import type { UserRole } from '@/entities/session/types'
import { getGoToPageItemsFromCatalog } from '@/widgets/navigation/appNavigationCatalog'

export interface GoToPageItem {
  to: string
  label: string
  group: string
  doctorOnly?: boolean
  adminOnly?: boolean
  keywords?: string[]
  state?: Record<string, unknown>
}

/** Páginas e atalhos para a paleta de busca (Ctrl+K). */
export const getGoToPageItems = (opts: {
  role: UserRole
  isSystemAdmin: boolean
}): GoToPageItem[] => getGoToPageItemsFromCatalog(opts)
